import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

/*
 * Fontes hospedadas junto do painel, não vindas do Google.
 *
 * Três motivos, na ordem: o painel roda embutido no sistema do cliente, e uma
 * requisição a fonts.googleapis.com em cada carregamento leva o IP de quem
 * atende para fora; instalações em rede interna podem não ter saída para a
 * internet, e a fonte que não carrega derruba a identidade da tela inteira; e o
 * subconjunto latino pesa poucos KB, servidos do mesmo host, sem uma segunda
 * conexão TLS antes do primeiro texto aparecer.
 *
 * Só os pesos usados pelo `styles.css` — cada peso é um arquivo.
 */
import '@fontsource/montserrat/latin-400.css';
import '@fontsource/montserrat/latin-500.css';
import '@fontsource/montserrat/latin-600.css';
import '@fontsource/montserrat/latin-700.css';
import '@fontsource/montserrat/latin-800.css';
// Face de dados: telefone, id, cronômetro, JSON. Dígito de largura fixa é o que
// impede o cronômetro de dançar a cada segundo.
import '@fontsource/jetbrains-mono/latin-400.css';
import '@fontsource/jetbrains-mono/latin-500.css';

import './styles.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Elemento #root não encontrado.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
